import { useQuery } from '@tanstack/react-query';

import { getAustralianStates } from '@/api/patients/getAustralianStates';
import { QueryKey } from '@/data/query';

type AustralianStates = {
  id: number;
  name: string;
};

export const useGetAustralianStates = () => {
  const { data, isError, isLoading } = useQuery<AustralianStates[]>({
    queryKey: [QueryKey.GetAustralianStates],
    queryFn: () => getAustralianStates()
  });

  return {
    data,
    isError,
    isLoading
  };
};
